import React from "react";

interface ButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  type?: "button" | "submit";
  loading?: boolean;
}

const ContinueButton: React.FC<ButtonProps> = ({
  onClick,
  disabled = false,
  className = "",
  children = "Continue",
  type = "button",
  loading = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      className={`w-fit font-Acumin rounded-[8px] bg-primary font-bold text-[14px] text-white  py-4 sm:py-3    px-5 sm:px-8 flex justify-center items-center   transition-colors duration-300 hover:bg-darkgrey disabled:bg-gray-400 disabled:cursor-not-allowed ${className}`}
    >
      {loading ? (
        <div className="w-5 h-5 border-2 m-auto border-white border-t-transparent border-solid rounded-full animate-spin"></div>
      ) : (
        <span className="leading-none font-bold text-[14px] text-white font-Acumin pt-1">
          {children}
        </span>

        // children
      )}
    </button>
  );
};

export default ContinueButton;
